import { Attributes, DateUtils, Misc, Rules, Validation, ValueObject } from '@singularsystems/neo-core';

export enum LogLevel {
    Information = "Information",
    Warning = "Warning",
    Error = "Error",
    Fatal = "Fatal"
}

export default class LogCriteria extends ValueObject {

    constructor() {
        super();
        this.makeObservable();
    }

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.UTC)
    public fromDate: Date = DateUtils.add(new Date(), { hours: -2 });

    public level: string | null = LogLevel.Error;

    // Client only properties / methods

    protected static addBusinessRules(rules: Validation.Rules<LogCriteria>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Log Criteria";
    }
}